<div class="root-container">
	<div class="forgot-password-box">
		<div *ngIf="(forgotPasswordLoading$ | async) === false && (success$ | async ) === false">
			<ng-container *ngTemplateOutlet="renewPasswordHeader"></ng-container>
			<!-- submit email -->
			<form class="forgot-password-form" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
				<div class="input-container">
					<app-smash-input type="text" placeholder="{{ 'FORGOT_PASSWORD_PLACEHOLDER_USERNAME' | translate }}" formControlName="email"
						[error]="submitted && f.email.errors">
						<div *ngIf="!!(forgotPasswordError$ | async)" error>{{ ( forgotPasswordError$ | async | translate) }}</div>
						<div *ngIf="submitted && f.email.invalid" error translate>SIGNIN_ALERT_MESSAGE_INCORRECT_EMAIL</div>
					</app-smash-input>
				</div>
				<ng-container *ngTemplateOutlet="renewPasswordInstructions"></ng-container>
				<div class="forgot-password-form-footer">
					<button type="button" class="btn white" [routerLink]="['/signin']" translate>FORGOT_PASSWORD_BUTTON_LABEL_CANCEL</button>
					<button class="btn red" type="submit" translate>FORGOT_PASSWORD_BUTTON_LABEL_SEND</button>
				</div>
			</form>
		</div>
		<!-- loading -->
		<div *ngIf="(forgotPasswordLoading$ | async) === true ">
			<div class="loading-spinner-container">
                <div class="loading-spinner-grey"></div>
            </div>
		</div>

		<!-- confirmation message -->
		<div *ngIf="(forgotPasswordLoading$ | async) === false && (success$ | async) === true ">
			<ng-container *ngTemplateOutlet="almostDoneHeader"></ng-container>
			<ng-container *ngTemplateOutlet="almostDoneInstructions"></ng-container>

			<div class="forgot-password-form-footer">
				<div></div>
				<button type="button" class="btn red" [routerLink]="['/signin']" translate>FORGOT_PASSWORD_SUCCESS_BUTTON_LABEL_OK</button>
			</div>
		</div>
	</div>
</div>

<!-- Renew password header template-->
<ng-template #renewPasswordHeader>
	<div class="forgot-password-header">
		<div class="logo">
			<i class="icon-smash_icologo_chip"></i>
		</div>
		<h1 class="title" translate>FORGOT_PASSWORD_TITLE</h1>
	</div>
</ng-template>

<!-- Almost done header template-->
<ng-template #almostDoneHeader>
	<div class="forgot-password-header">
		<div class="logo">
			<i class="icon-smash_icologo_chip"></i>
		</div>
		<h1 class="title" translate>FORGOT_PASSWORD_SUCCESS_TITLE</h1>
	</div>
</ng-template>

<!-- Renew password instructions template-->
<ng-template #renewPasswordInstructions>
	<div class="forgot-password-instructions">
		<p translate>FORGOT_PASSWORD_STEP_1</p>
		<p translate>FORGOT_PASSWORD_STEP_2</p>
		<p translate>FORGOT_PASSWORD_STEP_3</p>
	</div>
</ng-template>

<!-- Almost done instructions template-->
<ng-template #almostDoneInstructions>
	<div class="forgot-password-instructions">
		<p translate>FORGOT_PASSWORD_SUCCESS_STEP_1</p>
		<p translate>FORGOT_PASSWORD_SUCCESS_STEP_2</p>
		<p translate>FORGOT_PASSWORD_SUCCESS_STEP_3</p>
	</div>
</ng-template>